import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { SITE_COPY } from "@/lib/siteContent";

/** Destinos por tarjeta (índices alineados con SITE_COPY.services.items). */
const TARGETS = [
  { to: "/vende-tu-propiedad" as const },
  { to: "/$operation/$type" as const, params: { operation: "venta", type: "departamentos" } },
  { to: "/$operation/$type" as const, params: { operation: "alquiler", type: "departamentos" } },
];

export function ServicesSection() {
  const { lang } = useI18n();
  const c = SITE_COPY[lang].services;

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">{c.eyebrow}</p>
      <h2 className="mt-3 font-serif text-3xl text-foreground md:text-5xl">{c.title}</h2>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {c.items.map((s, i) => (
          <article
            key={s.n}
            className="flex flex-col rounded-2xl border border-border bg-card p-7 transition hover:shadow-card"
          >
            <span className="font-serif text-4xl text-accent/50">{s.n}</span>
            <h3 className="mt-4 text-lg font-semibold text-foreground">{s.title}</h3>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{s.text}</p>
            <Link
              to={TARGETS[i]!.to as never}
              params={TARGETS[i]!.params as never}
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline"
            >
              {s.cta} <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
